// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports
import {GlobalCreateMenu} from '@github-ui/global-create-menu'
import {useRef, useState} from 'react'

import {useDeferredPayloadSlice} from '../utils/DeferredNavPayloadContext'

export function LazyGlobalCreateMenu() {
  const [isOpen, setIsOpen] = useState(false)
  const anchorRef = useRef<HTMLElement | null>(null)
  const {data: createMenuProps, isPending} = useDeferredPayloadSlice('create_menu')

  return (
    <GlobalCreateMenu
      {...createMenuProps}
      isOpen={isOpen && !isPending}
      setIsOpen={setIsOpen}
      anchorRef={anchorRef}
      isLoading={isOpen && isPending}
    />
  )
}
